<template>
  <div class="contact-container">
    <div class="flex-group-me mb-3">
      <img :src="logo" class="logo-contact" alt="" />
    </div>
    <div class="text-center font19 mb-3">{{ $t('contactComp.contactUs') }}</div>
    <div class="text-center mb-3">{{ $t('contactComp.contactViaPlatforms') }}</div>
    <div class="flex-group-me mb-3">
      <template v-if="!loader">
        <div v-for="social in socials" class="all-cocials" :key="social">
          <a target="_blank" :href="social.link" :title="social.name">
            <img :src="social.icon" class="social-img" alt="" />
          </a>
        </div>
      </template>
      <template v-else>
        <Skeleton width="40px" height="40px" shape="circle" class="mb-2"></Skeleton>
        <Skeleton width="40px" height="40px" shape="circle" class="mb-2"></Skeleton>
        <Skeleton width="40px" height="40px" shape="circle" class="mb-2"></Skeleton>
      </template>
    </div>
    <div class="flex-group-me gap-mid contactNums" v-if="!loader">
      <a :href="'tel:' + phone" class="flex-sm-gap">
        <div class="icon-contact">
          <img :src="phoneImg" alt="" />
        </div>
        <div>{{ phone }}</div>
      </a>
      <a :href="'mailto:' + email" class="flex-sm-gap">
        <div class="icon-contact">
          <img :src="envImg" alt="" />
        </div>
        <div>{{ email }}</div>
      </a>
    </div>
    <div v-else class="flex-group-me gap-mid contactNums">
      <Skeleton width="130px" height="10px" class="mb-2"></Skeleton>
      <Skeleton width="130px" height="10px"  class="mb-2"></Skeleton>
    </div>
  </div>
</template>

<script setup>
// imports
import { ref, onMounted, defineProps } from "vue";
import Skeleton from "primevue/skeleton";

//props
const props = defineProps(["loader", "logo", "phone", "email", "socials"]);

// reactive state

const phoneImg = ref(require("@/assets/imgs/Group 179022.png"));
const envImg = ref(require("@/assets/imgs/Group 179020.png"));

// functions

// lifecycle hooks
onMounted(() => {
  console.log(props);
});
</script>
